import React, { LegacyRef, ReactNode } from 'react'
import { Icon } from '../Icon'

export interface MenuItemInterface {
  label?: string
  onClick?: () => void
  icon: string
  iconColor?: string
  textColor?: string
  display?: boolean
}

interface MenuProps {
  isOpen?: boolean
  items: MenuItemInterface[]
  children: ReactNode
  type?: string

  wrapperRefNotificationMenu: LegacyRef<HTMLDivElement> | undefined
}

const ButtonMenue: React.FC<MenuProps> = ({
  isOpen,
  items,
  children,
  type,
  wrapperRefNotificationMenu,
}) => {
  return (
    <>
      <div
        ref={wrapperRefNotificationMenu}
        className={`${type == 'table' ? 'absolute' : 'relative'} z-15`}
      >
        {children}
        {isOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl z-10 p-1 cursor-pointer">
            <div className="py-1">
              {items?.map((item, index) => (
                <div
                  key={index}
                  onClick={item.onClick}
                  className={`${item.display == false ? 'hidden' : 'flex'} flex gap-2 px-4 py-3 hover:bg-gray-100 w-full rounded-lg group`}
                >
                  {item?.icon && (
                    <Icon
                      name={item?.icon}
                      width={16}
                      height={16}
                      strokeWidth={1}
                      stroke={item?.iconColor ? item?.iconColor : '#02698C'}
                    />
                  )}
                  <p
                    className={`group-hover:text-text2 text-xs hover:font-medium font-medium ${item?.textColor ? item?.textColor : 'text-text1'}`}
                  >
                    {item.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default ButtonMenue
